import { render, staticRenderFns } from "./RegisterFullScreen.vue?vue&type=template&id=45c12b57"
import script from "./RegisterFullScreen.vue?vue&type=script&lang=js"
export * from "./RegisterFullScreen.vue?vue&type=script&lang=js"
import style0 from "./RegisterFullScreen.vue?vue&type=style&index=0&id=45c12b57&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports